import { render, staticRenderFns } from "./Produkte.vue?vue&type=template&id=a83f3ffa&scoped=true"
import script from "./Produkte.vue?vue&type=script&lang=ts"
export * from "./Produkte.vue?vue&type=script&lang=ts"
import style0 from "./Produkte.vue?vue&type=style&index=0&id=a83f3ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83f3ffa",
  null
  
)

export default component.exports